import SHRoleEdit from './src/edit.vue';

/* istanbul ignore next */
SHRoleEdit.install = function(Vue) {
  Vue.component('sh-role-edit', SHRoleEdit);
};

export default SHRoleEdit;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/edit/index.js